import { eqGeoCoord, GeoCoord } from "lib/at-data/GeoCoord";
import * as Eq from "fp-ts/Eq";
import * as A from "fp-ts/Array";

export type FloorPlanForMap = [string, Array<GeoCoord>];

export const FloorPlanForMapEq = Eq.tuple(Eq.eqStrict, A.getEq(eqGeoCoord));
